<template>
  <v-dialog v-model="dialog.value" persistent max-width="470">
    <template v-slot:activator="{ on }">
      <v-btn color="green lighten-2" block v-on="on">Zakończ</v-btn>
    </template>
    <v-card>
      <v-toolbar :color="modalColor" dark flat>
        <v-toolbar-title>Ostrzeżenie</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="mt-4">
        <p>Czy na pewno chcesz zakończyć lekcję?</p>
        <p>Po zakończeniu nie będzie można już zmienić odpowiedzi testów.</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="text--secondary" text :disabled="loading" @click="dialog.value = false">Nie</v-btn>
        <v-btn :color="modalColor" text :loading="loading" @click="$emit('yesClicked')">Tak</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  },
  data: function() {
    return {
      dialog: {
        value: false,
        loading: false
      }
    };
  },
  computed: {
    modalColor() {
      return 'warning';
    }
  }
};
</script>

<style lang="scss" scoped></style>
